import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d97b61c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "item__header" }
const _hoisted_3 = { class: "item__timestamp" }
const _hoisted_4 = { class: "item__buttons" }
const _hoisted_5 = ["onClick", "disabled"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["value", "data-textarea", "onInput", "readonly", "onBlur"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("ul", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.annotations, (annotation, index) => {
      return (_openBlock(), _createElementBlock("li", {
        key: index,
        class: "item",
        onClick: ($event: any) => (_ctx.onClickAnnotation(index, annotation))
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.formatContentPosition(annotation)), 1),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              class: "item__button item__button--update",
              onClick: _withModifiers(($event: any) => (_ctx.onClickUpdateAnnotation(index, annotation)), ["stop"]),
              disabled: _ctx.selectedIndex === index
            }, null, 8, _hoisted_5),
            _createElementVNode("button", {
              class: "item__button item__button--delete",
              onClick: _withModifiers(($event: any) => (_ctx.onClickDeleteAnnotation(index, annotation)), ["stop"])
            }, null, 8, _hoisted_6)
          ])
        ]),
        _createElementVNode("textarea", {
          value: annotation.text,
          "data-textarea": index,
          onInput: ($event: any) => (_ctx.onInputAnnotation($event, index, annotation)),
          maxlength: "500",
          readonly: _ctx.selectedIndex !== index,
          onBlur: ($event: any) => (_ctx.onBlurAnnotation($event, index, annotation))
        }, null, 40, _hoisted_7)
      ], 8, _hoisted_1))
    }), 128))
  ]))
}